/** @format */

import React from 'react';

const AccountDesignsOrdersContextDefault = {
    order: {},
    size: {},
    designs_order: {},
    design: {}
};

// TODO replace all passed props in the account to use this instead
const AccountDesignsOrdersContext = React.createContext(AccountDesignsOrdersContextDefault);

export {AccountDesignsOrdersContext, AccountDesignsOrdersContextDefault};
